module.exports = __webpack_public_path__ + "img/img_dmain1.3d208f11.jpg";